import { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { api } from '@iblai/ibl-web-react-common';

export default function useInviteNewUser() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState('');
  const auth = useSelector((state) => state.auth.data);

  const handleChange = (event) => {
    setEmail(event.target.value);
  };

  const handleCreateInvitationSuccess = (data) => {
    setEmail('');
    setSubmitting(false);
    toast.success('Invitation has been successfully submitted');
  };

  const handleCreateInvitationError = (error) => {
    setSubmitting(false);
    toast.error('There was an issue submitting the invitation');
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      email: email,
      platform_key: auth?.tenant?.key,
    };
    setSubmitting(true);
    api.ibldmplatform.createCatalogInvitationsPlatform(
      data,
      handleCreateInvitationSuccess,
      handleCreateInvitationError
    );
  };

  return { email, submitting, handleSubmit, handleChange };
}
